import { Badge } from 'antd';
import { useMemo } from 'react';
import smartThommyClean from '../../../../../assets/images/smart_thommy/st_topbar_clean.png';
import smartThommyIssue from '../../../../../assets/images/smart_thommy/st_topbar_issue.png';
import styles from './smart-assistant-topbar-btn.module.scss';

interface SmartAssistantTopbarButtonProps {
  onClick?: () => void;
  issueCount?: number;
}

export default function SmartAssistantTopbarButton(
  props: SmartAssistantTopbarButtonProps
) {
  const iconAsset = useMemo(() => {
    if (props.issueCount && props.issueCount > 0) {
      return smartThommyIssue;
    }
    return smartThommyClean;
  }, [props.issueCount]);

  const icon = (
    <img className={styles['icon']} src={iconAsset} alt="Smart Thommy Icon" />
  );

  return (
    <Badge count={props.issueCount} offset={[-2, 11]}>
      <div className={styles['button']} onClick={props.onClick}>
        {icon}
      </div>
    </Badge>
  );
}
